import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=bbe621d2&scoped=true"
import script from "./DeleteItem.vue?vue&type=script&lang=js"
export * from "./DeleteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe621d2",
  null
  
)

export default component.exports